import React from 'react';

/**
 * Лента выбранных фильтров над таблицей.
 *
 * Нужна потому, что сам список применений зажат в прокрутку — их два десятка, и
 * целиком они выдавливают таблицу за экран. Выбранный чип при этом уезжает из
 * видимой части, и таблица пустеет «без причины»: менеджер задал плотность, а
 * сверху висит применение из прошлого поиска, которого не видно.
 *
 * Здесь всё выбранное всегда на виду и снимается в одно нажатие.
 */
const InsulationPickerActiveFilters = ({ filters, onRemove, onReset }) => {
  if (filters.length === 0) {
    return null;
  }

  return (
    <div className="ins-pick__active" role="group" aria-label="Выбранные фильтры">
      <span className="ins-pick__active-title">Фильтры:</span>

      {filters.map((filter) => (filter.removable === false ? (
        // Вид материала снять нельзя — он выбран всегда. Показываем его меткой
        // без крестика: в ленте он объясняет, почему таблица может быть пустой.
        <span key={`${filter.type}:${filter.key}`} className="ins-pick__active-chip is-fixed">
          {filter.label}
        </span>
      ) : (
        <button
          key={`${filter.type}:${filter.key}`}
          type="button"
          className="ins-pick__active-chip"
          onClick={() => onRemove(filter)}
          title="Снять фильтр"
        >
          {filter.label}
          <span className="ins-pick__active-x" aria-hidden="true">×</span>
        </button>
      )))}

      {filters.some((filter) => filter.removable !== false) && (
        <button type="button" className="ins-pick__active-reset" onClick={onReset}>
          Сбросить все
        </button>
      )}
    </div>
  );
};

export default InsulationPickerActiveFilters;
